<script>
import { auth } from '@/firebase' // Import the auth object from your firebase.js file
import { signInWithEmailAndPassword } from 'firebase/auth'
import ResetPassword from './ResetPassword.vue'

let errors = [
  "The email and password you entered don't match",
  'Enter your email address to continue',
  "That email address isn't correct",
]

export default {
  name: 'SignIn',

  components: {
    ResetPassword,
  },

  props: {},

  emits: ['close', 'authenticated'],

  data: () => ({
    authForm: {
      email: '',
      password: '',
    },
    isLoading: false,
    errors: null,
    showResetModal: false,
    redirectForm: {
      path: null,
      application: null,
    },
  }),

  computed: {
    ok() {
      return true
    },
  },

  watch: {},

  beforeUnmount() {
    console.log('before unmount')
  },

  async unmounted() {},

  async mounted() {
    console.log('SignIn', this.$route.query)
    if (this.$route.query?.r) {
      this.redirectForm.path = this.$route.query.r
      this.redirectForm.application = this.$route.query?.a
    }
  },

  methods: {
    async handleSubmit() {
      this.isLoading = true
      this.errors = null

      try {
        const userCredential = await signInWithEmailAndPassword(
          auth,
          this.authForm.email,
          this.authForm.password
        )
        // Signed in
        const user = userCredential.user
        console.log('User signed in:', user)

        // You can add additional logic here, such as redirecting to a dashboard
        // this.$router.push('/dashboard')
        this.$emit('authenticated', userCredential, this.redirectForm)
      } catch (error) {
        console.error('Error signing in:', error)
        this.errors = error.message
      } finally {
        this.isLoading = false
      }
    },

    handleTroubleSigningIn() {
      this.showResetModal = true
    },

    handleCloseResetModal() {
      this.showResetModal = false
    },
  },
}
</script>

<template>
  <div class="container has-text-centered">
    <div class="firebaseui-auth-container">
      <div class="firebaseui-card-header" style="">
        <img
          src="@/assets/Liff-marvin-white.png"
          style="height: 4rem"
          alt="Liff logo" />
      </div>

      <div class="firebaseui-container">
        <h1 class="firebaseui-title">Sign in</h1>

        <form class="p-4 has-text-left" @submit.prevent="handleSubmit">
          <b-field label="Email">
            <b-input
              v-model="authForm.email"
              data-test="formEmail"
              expanded
              type="email"
              name="email"
              autocomplete="username" />
          </b-field>

          <b-field label="Password">
            <b-input
              v-model="authForm.password"
              data-test="formPassword"
              expanded
              type="password"
              name="password"
              autocomplete="current-password" />
          </b-field>

          <div class="signin-error-wrapper">
            <p v-if="errors" class="has-text-danger">
              {{ errors }}
            </p>
          </div>

          <div class="is-flex is-justify-content-space-between">
            <div class="">
              <router-link
                to="/trouble"
                class=""
                href="#"
                @click.prevent="handleTroubleSigningIn">
                Trouble signing in?
              </router-link>
            </div>
            <div class="">
              <b-button
                variant="primary"
                data-test="submitBtn"
                :loading="isLoading"
                :disabled="isLoading || !ok"
                native-type="submit"
                @click="handleSubmit">
                Sign In
              </b-button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- Reset Password Modal -->
    <b-modal
      v-model="showResetModal"
      :can-cancel="['escape', 'outside']"
      trap-focus
      aria-role="dialog"
      aria-label="Reset Password"
      close-button-aria-label="Close">
      <reset-password @close="handleCloseResetModal" />
    </b-modal>
  </div>
</template>

<style scoped lang="scss"></style>
